module.exports = __webpack_public_path__ + "img/level_alert.257c6e13.svg";